import React, { useEffect, useRef, useState } from 'react';
import { ReactZoomPanPinchRef, TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch';
import SeatSelectorControl from '@/components/ui/SeatSelector/_components/SeatSelectorControl';

import { StyledSeatOptionWrapper } from '@/components/ui/SeatSelector/SeatSelector.styled.ts';
import { StyledInputFieldError } from '@/components/ui/PersonalDetailEntry/PersonalDetailEntry.styled.ts';
import theme from '@/data/theme';
import { MapArea } from '@/data/venueMapData';
import { useLocation } from 'react-router-dom';
import { SeatAPIModel } from '@/apiModels/SeatReservation';
import AdminSVGMapComponent from '@/components/ui/SeatSelector/_components/AdminMapComponent';
import SeatBookingStatusModal from '@/components/ui/Modals/BookingStatusModal';
import { StyledAdminLegend, StyledAdminLegendWrapper } from '@/views/AdminView/AdminView.styled.ts';

interface Props {
  errorText: string;
  data: SeatAPIModel[] | undefined;
  venueMap: MapArea;
  eventId: string;
}

const AdminSeatSelector: React.FunctionComponent<Props> = ({
  errorText,
  data,
  venueMap,
  eventId,
}) => {
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState<boolean>(false);
  const [selectedReservation, setSelectedReservation] = useState<SeatAPIModel | null>(null);
  const location = useLocation();
  const transformComponentRef = useRef<ReactZoomPanPinchRef | null>(null);

  useEffect(() => {
    const switchArea = localStorage.getItem('switch');

    if (location.pathname.split('/')[2] !== switchArea) {
      localStorage.setItem('selectedReservations', JSON.stringify([]));
    }
  }, [location.pathname]);

  const onCancel = () => {
    setIsConfirmModalOpen(false);
  };

  return (
    <TransformWrapper
      ref={transformComponentRef}
      initialScale={1}
      smooth
      limitToBounds
      disablePadding
      centerOnInit
    >
      {(utils) => (
        <React.Fragment>
          <TransformComponent
            wrapperStyle={{
              borderRadius: '5px',
              width: '100%',
              backgroundColor: '#362315',
            }}
            contentStyle={{
              width: '100%',
              aspectRatio: '1/1.28',
              border: errorText ? `2px solid ${theme.colors.danger}` : 'none',
            }}
          >
            {data && (
              <AdminSVGMapComponent
                key={JSON.stringify(data)}
                seats={data}
                modelDispatcher={setIsConfirmModalOpen}
                setSelectedReservation={setSelectedReservation}
                venueMap={venueMap}
              />
            )}
          </TransformComponent>
          {errorText && <StyledInputFieldError>{errorText}</StyledInputFieldError>}
          <StyledSeatOptionWrapper>
            <StyledAdminLegendWrapper>
              {' '}
              <StyledAdminLegend $status={'available'}>Available</StyledAdminLegend>
              <StyledAdminLegend $status={'disabled'}>Disabled</StyledAdminLegend>
              <StyledAdminLegend $status={'revel booked'}>Revel Booked</StyledAdminLegend>
              <StyledAdminLegend $status={'organizer booked'}>Organizer Booked</StyledAdminLegend>
              <StyledAdminLegend $status={'hold'}>Hold</StyledAdminLegend>
            </StyledAdminLegendWrapper>

            <SeatSelectorControl {...utils} />
          </StyledSeatOptionWrapper>
          {data && (
            <SeatBookingStatusModal
              key={selectedReservation?.id}
              isOpen={isConfirmModalOpen}
              onClose={onCancel}
              seatInformation={selectedReservation || ({} as SeatAPIModel)}
              eventId={eventId}
              seatId={selectedReservation?.id || ''}
            />
          )}
        </React.Fragment>
      )}
    </TransformWrapper>
  );
};

export default AdminSeatSelector;
